'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _feiseanna = require('../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _adjudication = require('./adjudication');

var _adjudication2 = _interopRequireDefault(_adjudication);

var _adjudicators = require('./adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _index = require('./announce/index');

var _index2 = _interopRequireDefault(_index);

var _awards = require('./awards');

var _awards2 = _interopRequireDefault(_awards);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _finalize = require('./finalize');

var _finalize2 = _interopRequireDefault(_finalize);

var _finance = require('./finance');

var _finance2 = _interopRequireDefault(_finance);

var _manage = require('./manage');

var _manage2 = _interopRequireDefault(_manage);

var _personnel = require('./personnel');

var _personnel2 = _interopRequireDefault(_personnel);

var _printedPlacements = require('./printed-placements/printed-placements.mdl');

var _printedPlacements2 = _interopRequireDefault(_printedPlacements);

var _publish = require('./publish');

var _publish2 = _interopRequireDefault(_publish);

var _registration = require('./registration');

var _registration2 = _interopRequireDefault(_registration);

var _preFeisPrintouts = require('./pre-feis-printouts');

var _preFeisPrintouts2 = _interopRequireDefault(_preFeisPrintouts);

var _reports = require('./reports');

var _reports2 = _interopRequireDefault(_reports);

var _schedule = require('./schedule');

var _schedule2 = _interopRequireDefault(_schedule);

var _schools = require('./schools');

var _schools2 = _interopRequireDefault(_schools);

var _scores = require('./scores/scores.mdl');

var _scores2 = _interopRequireDefault(_scores);

var _stages = require('./stages');

var _stages2 = _interopRequireDefault(_stages);

var _syllabus = require('./syllabus');

var _syllabus2 = _interopRequireDefault(_syllabus);

var _products = require('./products');

var _products2 = _interopRequireDefault(_products);

var _tabulations = require('./tabulations');

var _tabulations2 = _interopRequireDefault(_tabulations);

var _deregister = require('./deregister');

var _deregister2 = _interopRequireDefault(_deregister);

var _textract = require('./textract');

var _textract2 = _interopRequireDefault(_textract);

var _metrics = require('./metrics');

var _metrics2 = _interopRequireDefault(_metrics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//ng modules


var FeisAdminController = function FeisAdminController() {
  _classCallCheck(this, FeisAdminController);
};

exports.default = angular.module('ifeis.routes.feiseanna.one.admin', ['ui.router', 'ngMaterial', 'ifeis.feiseanna', 'ifeis.routes.feiseanna.one.admin.adjudication', 'ifeis.routes.feiseanna.one.admin.adjudicators', 'ifeis.routes.feiseanna.one.admin.announce', 'ifeis.routes.feiseanna.one.admin.awards', 'ifeis.routes.feiseanna.one.admin.dashboard', 'ifeis.routes.feiseanna.one.admin.finalize', 'ifeis.routes.feiseanna.one.admin.finance', 'ifeis.routes.feiseanna.one.admin.manager', 'ifeis.routes.feiseanna.one.admin.personnel', 'ifeis.routes.feiseanna.one.admin.printed-placements', 'ifeis.routes.feiseanna.one.admin.publish', 'ifeis.routes.feiseanna.one.admin.registration', 'ifeis.routes.feiseanna.one.admin.pre-feis-printouts', 'ifeis.routes.feiseanna.one.admin.reports', 'ifeis.routes.feiseanna.one.admin.schedule', 'ifeis.routes.feiseanna.one.admin.schools', 'ifeis.routes.feiseanna.one.admin.scores', 'ifeis.routes.feiseanna.one.admin.stages', 'ifeis.routes.feiseanna.one.admin.syllabus', 'ifeis.routes.feiseanna.one.admin.products', 'ifeis.routes.feiseanna.one.admin.tabulations', 'ifeis.routes.feiseanna.one.admin.deregister', 'ifeis.routes.feiseanna.one.admin.textract', 'ifeis.routes.feiseanna.one.admin.metrics']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin', {
    abstract: true,
    url: '/admin',
    template: require('./tpl.html'),
    controller: 'FeisAdminController',
    resolve: {
      isPermitted: function isPermitted($state, feis, account, isGod, metadata) {
        if (!account && !isGod && !metadata.grants.length) {
          $state.go('feiseanna.one.landing-page', feis);
        }
      }
    }
  });
}).controller('FeisAdminController', FeisAdminController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/index.js
// module id = 546
// module chunks = 0